import { render, staticRenderFns } from "./ContractsRecordCreateModal.vue?vue&type=template&id=5665f15c"
import script from "./ContractsRecordCreateModal.vue?vue&type=script&lang=js"
export * from "./ContractsRecordCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports